import { Component, Inject, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SANDRETaxionModel } from 'src/app/models/SANDRE-taxon-model';
import { CoreData } from '../../core-data';
import { Taxon } from 'src/app/domain/Analyse/taxon';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { SANDREService } from 'src/app/services/SANDRE-service';
import * as _ from 'lodash'
import { NotificationManager } from '../../notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-taxon-cyano-box',
    templateUrl: './taxon-cyano-box.component.html',
    styleUrls: ['./taxon-cyano-box.component.scss']
})
export class TaxonCyanoBoxComponent implements OnInit {

    public model: Taxon = new Taxon()
    public IsCreation: boolean;

    public SearchText: string;
    public TaxonOptionList: SANDRETaxionModel[] = [];
    private subject: Subject<string> = new Subject();
    IsFocused: boolean;
    AlreadyPicked: Taxon[] = [];
    NewQuantite: number;
    NewColonie: number = 1;

    get CanAdd() {
        return true
    }

    constructor(
        public CoreData: CoreData,
        public dialogRef: MatDialogRef<TaxonCyanoBoxComponent>,
        public SANDREService: SANDREService,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data.taxon) {
            this.model = Object.assign({}, data.taxon);
            this.SearchText = `${this.model.Code} - ${this.model.NomGenre}`;
        }

        if (data.alreadyPicked) {
            this.AlreadyPicked = Object.assign([], data.transectAlreadyPicked);
        }

        setTimeout(() => {
            this.IsFocused = true;
        }, 100);
    }

    ngOnInit(): void {
        this.subject.pipe(
            debounceTime(500)
        ).subscribe((s) => {
            this.searchTaxon(s);
        });
    }

    onKeyUp() {
        if (!this.SearchText) {
            this.TaxonOptionList = [];
            return;
        }

        this.subject.next(this.SearchText);
    }

    displayFn(m: SANDRETaxionModel | string): string {
        if (m instanceof SANDRETaxionModel) {
            if (!m.Ordre && !m.Famille) {
                return `${m.Genre}`
            }
            if (m.Genre) {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille !== '' ? m.Famille + ' /' : ''} ${m.Genre}`;
            } else {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille}`;
            }
        }
        if (typeof (m) === 'string') {
            return m;
        }
    }

    setSelectedTaxon(event: MatAutocompleteSelectedEvent) {

        const selectedOption = this.TaxonOptionList.find(x => x.Code === event.option.value.Code);
        if (selectedOption) {
            this.model.NomGenre = selectedOption.Genre;
            this.model.IsPhyto = selectedOption.IsPhyto;
            if (this.model.IsPhyto)
                this.NewColonie = undefined;
        }
    }

    async searchTaxon(s: string) {

        this.TaxonOptionList = [];
        this.SANDREService.getTaxonList(EInterventionType.Cyano, s).subscribe(x => {
            this.TaxonOptionList = _.differenceWith(x, this.AlreadyPicked.map(y => y.SandreCode), this.isEqual);
        });
    }

    isEqual(t0, t1) {
        return t0.Code === t1 ? true : false;
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {

        if (!this.CanAdd) {
            return;
        }

        if (this.model.Colonie >= 100)
            NotificationManager.handleWarning('Attention vous avez atteint 100 colonies', this.snackBar)
        this.model.Quantite = this.NewQuantite;
        this.model.Colonie = this.NewColonie;
        this.dialogRef.close(this.model);
    }
}
